import { TableContainer, Table, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTable = styled(Table)(
  ({ theme }) => `
    & td {
      background-color: ${theme.palette.bg.main};

      &.label {
        width: 15%;
        background-color: ${theme.palette.bg.dark};

        text-align: center;
        color: white;
      }
    }
  `,
);

export default function AdminTable({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <TableContainer>
      <StyledTable>
        <TableBody>{children}</TableBody>
      </StyledTable>
    </TableContainer>
  );
}
